import axiosInstance from "./axios-config";

export const getOtaFileUploadSignedUrl = async (
  version: string,
  extension: string
) => {
  const { data } = await axiosInstance.post<{ url: string; path: string }>(
    `/ota/s3-signed-url/put`,
    { version, extension }
  );
  return data;
};

export const enableOta = async (id: number) => {
  const { data } = await axiosInstance.put(`/ota/${id}/enable`);
  return data;
};
